import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import MetaTags from "react-meta-tags";
import SweetAlert from "react-bootstrap-sweetalert";
import { Card, CardBody, Col, Container, Row, FormGroup, Label, Modal, ModalHeader, ModalBody } from "reactstrap";
import { AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { motion, AnimatePresence } from "framer-motion";

import { priorityUAEApi } from "../../services/PriorityUAEService";
import { Newspaper, BadgePlus, ChevronDown, Package, CheckCircle, AlertCircle, BicepsFlexed, FileBox, Rows2, MessageCircleReply, ScrollText } from "lucide-react";
import Breadcrumbs from "../../components/Breadcrumb";
import PageLoader from "../../components/Loaders/newPageLoader";
import { showToast } from "../../components/Toast";
import useLoadingProgress from "../../hooks/useLoadingProgress";
import { MainContent } from "../../components/Table/MainContent";
import { BtnModal } from "../../components/Table/BtnModal";
import InputMask from "react-input-mask";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import Select, { components } from "react-select";

export default function PriorityUAE({ profileData, loading }) {
  const {
    data = [],
    isLoading,
    isFetching,
    error,
    refetch,
  } = priorityUAEApi.useFetchAllPriorityUAEQuery(undefined, {
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
  });

  const [addPriorityUAE] = priorityUAEApi.useAddPriorityUAEMutation();
  const [updatePriorityUAE] = priorityUAEApi.useUpdatePriorityUAEMutation();
  const [deletePriorityUAE] = priorityUAEApi.useDeletePriorityUAEMutation();

  const [priorityUAE, setPriorityUAE] = useState([]);
  const [slManagers, setSlManagers] = useState([]);
  // const [filteredPriorityUAE, setFilteredPriorityUAE] = useState([]);
  const [filters, setNoDbFilters] = useState([]);
  const [order, setSelectedOrder] = useState([]);
  const [profile, setSelectedProfile] = useState([]);
  const [logModalOrderId, setLogModalOrderId] = useState(null);
  const [showLogModal, setShowLogModal] = useState(false);
  //   const [access_user, setAccessSelectedUser] = useState([]);
  //   const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  //   const [departments, setDepartmentsData] = useState([]);
  //   const [accesses, setAccessesData] = useState([]);

  const { progress, step, visible } = useLoadingProgress({
    isLoading,
    isFetching,
  });

  const {
    data: logs = [],
    isLoading: logsLoading,
    isFetching: logsFetching,
    refetch: refetchLogs,
  } = priorityUAEApi.useGetLogsByOrderIdQuery(logModalOrderId, {
    skip: !showLogModal || !logModalOrderId,
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (data.priorityUAE && data.SlManagers) {
      setPriorityUAE(JSON.parse(JSON.stringify(data.priorityUAE)));
      setSlManagers(JSON.parse(JSON.stringify(data.SlManagers)));
    }
  }, [data]);
  console.log(data);
  const [cardHeight, setCardHeight] = useState(0);
  const cardRef = useRef(null);
  useEffect(() => {
    if (!cardRef.current) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const newHeight = entry.contentRect.height;
        if (newHeight > 0) setCardHeight(newHeight);
      }
    });
    resizeObserver.observe(cardRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  const filteredPriorityUAE = useMemo(() => {
    let result = [...priorityUAE];

    if (filters?.status?.length > 0) {
      result = result.filter((order) => filters.status.includes(order.status));
    } else {
      result = result.filter((row) => row.status !== "sent");
    }

    const isWH = profileData?.department?._id === "69b12949fad30e48f0dd2667";

    if (isWH) {
      result = result.filter((row) => row.sendDate || row.status === "only_pack");

      result = result.filter((row) => row.sendType);
    }

    return result;
  }, [filters, priorityUAE, profileData?.department?._id]);
  console.log(filteredPriorityUAE);
  // Toggle modal
  const defaultDateStr = () => new Date().toLocaleDateString("en-GB");

  const [modalNewOrder, setModalNewOrder] = useState(false);

  const defaultDate = useMemo(defaultDateStr, []);
  const [placedDate, setPlacedDate] = useState(defaultDate);
  const [sendDate, setSendDate] = useState(defaultDate);

  const [correctSendDate, setCorrectSendDate] = useState(true);

  const onChangeDate = (event) => {
    const { name, value } = event.target;
    // month is characters at positions 3 and 4 in dd/mm/yyyy
    const monthStr = value.substring(3, 5);
    const month = parseFloat(monthStr);

    const isInvalid = month > 12;

    if (name === "sendDate") {
      if (isInvalid) {
        setCorrectSendDate(false);
      } else {
        setCorrectSendDate(true);
        setSendDate(value);
      }
    }
  };

  /**
   * Toggles the visibility state of the "New Order" modal.
   * Uses a callback to invert the current modal state.
   *
   * @function
   * @returns {void}
   */
  const toggleNewOrderModal = useCallback(() => {
    setModalNewOrder((prev) => !prev);
  }, []);

  /**
   * Handles the event when the "New Order" button is clicked.
   * Resets the selected order and access selections, sets edit mode to false,
   * and opens the modal for creating a new order.
   */
  const handleNewOrderClick = () => {
    setSelectedOrder([]);
    setIsEdit(false);
    toggleNewOrderModal();
  };
  /**
   * Handles the event when a order is selected for editing.
   * Sets the selected order's details in the state, resets the selected access,
   * enables edit mode, and opens the order modal for editing.
   *
   * @param {Object} order - The order object containing order details to be edited.
   */
  const handleOrderClickEdit = (order) => {
    setSelectedOrder({
      _id: order._id,
      orderNumber: order.orderNumber,
      clientName: order.clientName,
      placedDate: order.placedDate,
      sendDate: order.sendDate,
      address: order.address,
      tracking: order.tracking,
      comments: order.comments,
      cod: order.cod,
      sendType: order.sendType,
      deliveryPaidBy: order.deliveryPaidBy,
      manager: order.manager,
      status: order.status,
    });

    setIsEdit(true);
    toggleNewOrderModal();
  };

  const ddmmyyyyToZulu = (ddmmyyyy) => {
    console.log("ddmmyyyy", ddmmyyyy);
    const [dd, mm, yyyy] = ddmmyyyy.split("/");
    return `${yyyy}-${mm}-${dd}T00:00:00.000Z`;
  };

  /**
   * Handles the submission of the new order or edit order form.
   * Depending on the mode (add or edit), it constructs the appropriate order object
   * and performs the corresponding API call to add or update a order in the system.
   * Displays toast notifications based on the outcome and toggles the order modal on success.
   *
   * @async
   * @function
   * @param {Event} e - The form submission event.
   * @param {Object} values - The form values containing order details.
   * @returns {Promise<void>}
   */
  const handleNewOrderSubmit = async (e, values) => {
    console.log("values", values);
    const selectedManager = slManagers.find((m) => m._id === values.manager);

    if (isEdit) {
      const updOrder = {
        _id: order._id,
        orderNumber: values.orderNumber,
        clientName: values.clientName,
        placedDate: ddmmyyyyToZulu(placedDate),
        sendDate: ddmmyyyyToZulu(sendDate),
        address: values.address,
        tracking: values.tracking,
        comments: values.comments,
        cod: values.cod,
        sendType: values.sendType,
        deliveryPaidBy: values.deliveryPaidBy,
        manager: values.manager,
        bitrixID: selectedManager.bitrixID,
        status: values.status,
      };
      try {
        console.log("before updatePriorityUAE");
        await updatePriorityUAE(updOrder).unwrap();
        toggleNewOrderModal();
        console.log("after updatePriorityUAE");
        showToast("Order is Updated");
      } catch (error) {
        console.error("Failed to Update new order:", error);
        showToast("Failed to Update Order information", "error");
      }
    } else {
      const newOrder = {
        orderNumber: values["orderNumber"],
        clientName: values["clientName"],
        placedDate: placedDate,
        sendDate: ddmmyyyyToZulu(sendDate),
        address: values["address"],
        tracking: values["tracking"],
        comments: values["comments"],
        cod: values["cod"],
        sendType: values["sendType"],
        deliveryPaidBy: values["deliveryPaidBy"],
        koruMSID: values["manager"],
        bitrixID: selectedManager.bitrixID,
        status: "",
      };
      try {
        console.log(newOrder);
        await addPriorityUAE(newOrder).unwrap();
        toggleNewOrderModal();
        showToast("New Order is Added");
      } catch (error) {
        console.error("Failed to add new order:", error);
        showToast("Failed to Add New Order", "error");
      }
    }
  };

  const [rowToDelete, setRowToDelete] = useState(null);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  /**
   * Handles the delete action when a order is clicked for deletion.
   * Sets the selected order, marks the order's ID for deletion, and displays the delete confirmation alert.
   *
   * @param {Object} order - The order object representing the order to be deleted.
   */
  const handleOrderClickDelete = (order) => {
    setSelectedOrder(order);
    setRowToDelete(order._id);
    setShowDeleteAlert(true);
  };

  const handleCloseLogModal = () => {
    setShowLogModal(false);
    setLogModalOrderId(null);
  };
  /**
   * Handles the deletion of a order.
   *
   * This asynchronous function attempts to delete the currently selected order.
   * On successful deletion, it resets relevant UI states and displays a success toast notification.
   * If the deletion fails, it logs the error and shows an error toast notification.
   * The function also ensures that any loading or deleting state can be reset after the operation.
   *
   * @async
   * @function handleDeleteOrder
   * @returns {Promise<void>} Resolves when the order deletion process is complete.
   */
  const handleDeleteOrder = async () => {
    try {
      //   setIsDeleting(true);
      await deletePriorityUAE(rowToDelete);
      setRowToDelete(null);
      setShowDeleteAlert(false);
      setSelectedOrder([]);
      showToast("Order deleted successfully");
    } catch (error) {
      console.error("Failed to delete row:", error);
      showToast("Failed to delete row", "error");
    } finally {
      // setIsDeleting(false); // Reset loading state after completion
    }
  };

  const handleSaveCell = async (oldValue, newValue, row, column) => {
    if (oldValue === newValue) return;

    const field = column.dataField;

    // --- 1) Сбор апдейта для сервера (безопасно к manager === null) ---
    const updateOrder = {
      _id: row._id,
      orderNumber: row.orderNumber,
      clientName: row.clientName,
      managerID: profileData?._id,
      oldValue: oldValue,
      ...(row.manager?.bitrixID ? { bitrixID: row.manager.bitrixID } : {}),
      [field]:
        field === "sendDate" && newValue
          ? new Date(newValue).toISOString() // нормализуем дату
          : newValue,
    };

    // --- 2) Подготовка нового локального состояния (валидируем правила) ---
    const nextRow = { ...row, [field]: updateOrder[field] };
    // если изменили sendType — проверим по дате
    if (field === "sendType" && newValue) {
      const allowed = isOptionEnabledForRow(newValue, nextRow.sendDate);
      if (!allowed) {
        showToast("This Send Type is unavailable for the selected date/time (UAE).", "warning");
        return; // не сохраняем вообще
      }
    }
    // если изменили sendDate — проверим текущий sendType
    if (field === "sendDate" && row.sendType) {
      const stillOk = isOptionEnabledForRow(row.sendType, updateOrder.sendDate);
      if (!stillOk) {
        nextRow.sendType = ""; // сбрасываем локально
      }
    }

    // --- 3) Оптимистичное обновление с возможностью отката ---
    let prevSnapshot;
    setPriorityUAE((prev) => {
      prevSnapshot = prev; // снимок для rollback
      return prev.map((item) => (item._id === row._id ? nextRow : item));
    });

    try {
      await updatePriorityUAE(updateOrder).unwrap();

      // если при смене sendDate мы локально очистили sendType — дожмём сервер
      if (field === "sendDate" && row.sendType && nextRow.sendType === "") {
        await updatePriorityUAE({
          _id: row._id,
          orderNumber: row.orderNumber,
          clientName: row.clientName,
          ...(row.manager?.bitrixID ? { bitrixID: row.manager.bitrixID } : {}),
          sendType: "",
        }).unwrap();
      }

      showToast("Update has been done");
    } catch (err) {
      // --- откат ---
      console.error("Failed to update row:", err);
      setPriorityUAE((prev) => prevSnapshot);
      showToast("Failed to update row", "error");
    }
  };

  const STATUS_OPTIONS = [
    {
      key: "under_work",
      label: "Under Work",
      icon: <BicepsFlexed size={18} className="me-2" />,
      colorClass: "bg-primary",
    },
    {
      key: "request_to_pack",
      label: "Sent Request to Pack",
      icon: <FileBox size={18} className="me-2" />,
      colorClass: "bg-warning",
    },
    {
      key: "packaged",
      label: "Packaged/Waiting Pickup",
      icon: <Package size={18} className="me-2" />,
      colorClass: "bg-info bg-gradient",
    },
    {
      key: "half_pack",
      label: "Half Pack",
      icon: <Rows2 size={18} className="me-2" />,
      colorClass: "pink-color",
    },
    {
      key: "sent",
      label: "Sent",
      icon: <CheckCircle size={18} className="me-2" />,
      colorClass: "bg-success bg-gradient",
    },

    {
      key: "stopped",
      label: "Stopped",
      icon: <AlertCircle size={18} className="me-2" />,
      colorClass: "bg-danger bg-gradient",
    },
    {
      key: "waiting_compensation_fee",
      label: "Waiting Compensation Fee",
      icon: <MessageCircleReply size={18} className="me-2" />,
      colorClass: "bg-dark bg-opacity-75",
    },
  ];

  const getStatusMeta = (key) => STATUS_OPTIONS.find((status) => status.key === key);

  /**
   * Renders the content for the "New Order" modal form.
   *
   * This component displays a multi-row form for creating or editing a order, including fields for personal information,
   * department, supervisor, position, contact details, leave days, access rights, and role. It uses AvField components
   * for validation and supports dynamic population of select options for departments and supervisors.
   *
   * @constant
   * @type {JSX.Element}
   * @param {Object} order - The order object containing current form values.
   * @param {Array} departments - Array of department objects for the department select field.
   * @param {Array} orders - Array of order objects for the supervisor select field.
   * @param {Object} error - Error object for displaying validation errors.
   * @returns {JSX.Element} The rendered form content for the modal.
   */
  const modalNewOrderContent = (
    <>
      <Row>
        <Col md={3}>
          <FormGroup className="mb-3">
            <AvField
              name="orderNumber"
              label="Invoice No"
              type="text"
              errorMessage="Invalid Invoice No"
              validate={{
                required: { value: true },
              }}
              value={order.orderNumber || ""}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup className="mb-3">
            <AvField
              name="clientName"
              label="Client Name"
              type="text"
              errorMessage="Invalid Client Name"
              validate={{
                required: { value: true },
              }}
              value={order.clientName || ""}
            />
          </FormGroup>
        </Col>
        <Col md={2}>
          <FormGroup className="mb-3">
            <AvField
              name="placedDate"
              label="Date"
              mask="99/99/9999"
              value={placedDate}
              onChange={(e) => setPlacedDate(e.target.value)}
              placeholder="DD/MM/YYYY"
              className="form-control input-mask"
              readOnly
              validate={{
                required: {
                  value: true,
                  errorMessage: "Date is required",
                },
                pattern: {
                  value: /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
                  errorMessage: "Use DD/MM/YYYY",
                },
              }}
            />
          </FormGroup>
        </Col>
        <Col md={2}>
          <FormGroup className="mb-3">
            <Label>Send Date</Label>
            <InputMask
              mask="99/99/9999"
              value={sendDate}
              name="sendDate"
              id="sendDate"
              onChange={onChangeDate}
              className={correctSendDate ? "form-control input-mask" : "form-control input-mask is-invalid"}
              placeholder="dd/mm/yyyy"
            />
            {!correctSendDate && <div className="invalid-feedback">Invalid Date. Please use dd/mm/yyyy format</div>}
          </FormGroup>
        </Col>
        <Col md={2}>
          <FormGroup className="mb-3">
            <AvField
              type="select"
              name="manager"
              className="form-select"
              label="Manager"
              errorMessage="Please select manager"
              validate={{
                required: {
                  value: true,
                },
              }}
              value={order.manager ? order.manager._id : profileData._id}
            >
              <option>Choose</option>
              {slManagers &&
                slManagers.map((manager) => {
                  return (
                    <option key={manager._id} value={manager._id}>
                      {manager.fname} {manager.sname}
                    </option>
                  );
                })}
            </AvField>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <FormGroup className="mb-3">
            <AvField name="tracking" label="Tracking" type="text" errorMessage="Invalid Tracking" value={order.tracking || ""} />
          </FormGroup>
        </Col>

        <Col md={3}>
          <FormGroup className="mb-3">
            <AvField name="cod" label="Cod Amount AED" type="text" errorMessage="Invalid Cod" value={order.cod || ""} />
          </FormGroup>
        </Col>

        <Col md={3}>
          <FormGroup className="mb-3">
            <AvField type="select" name="sendType" className="form-select" label="Send Type" value={order.sendType || ""}>
              <option>Select Send Type</option>
              <option key="sameDayDelivery" value="sameDayDelivery">
                Same day delivery. Place order before 9am UAE (2pm KST, 1pm MYT)
              </option>
              <option key="nextDayDelivery" value="nextDayDelivery">
                Next day delivery. Place order before 1pm UAE (5pm KST, 4pm MYT)
              </option>
              <option key="2hoursDelivery" value="2hoursDelivery">
                2 hours delivery (within Dubai) anytime between 8 AM and 4:30pm UAE (8:30pm KST, 7:30pm MYT)
              </option>
            </AvField>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup className="mb-3">
            <AvField type="select" name="deliveryPaidBy" className="form-select" label="Delivery Paid By" value={order.deliveryPaidBy || ""}>
              <option>Select Delivery Paid By</option>
              <option key="cashOnDelivery" value="cashOnDelivery">
                Cash on Delivery (CLIENT WILL PAY TO COURIER)
              </option>
              <option key="weCover" value="weCover">
                We cover delivery fee OR client paid already
              </option>
            </AvField>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup className="mb-3">
            <AvField name="address" label="Address" type="textarea" rows="5" errorMessage="Invalid address" value={order.address || ""} className="form-control" />
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup className="mb-3">
            <AvField name="comments" label="Comments" type="textarea" rows="5" errorMessage="Invalid Comment" value={order.comments || ""} className="form-control" />
          </FormGroup>
        </Col>
      </Row>
    </>
  );

  const getUaeParts = (dateLike) => {
    const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Dubai",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(d);

    const y = Number(parts.find((p) => p.type === "year")?.value || 0);
    const m = Number(parts.find((p) => p.type === "month")?.value || 0);
    const day = Number(parts.find((p) => p.type === "day")?.value || 0);
    return { y, m, d: day };
  };

  const isUaeSameDay = (a, b) => {
    const A = getUaeParts(a);
    const B = getUaeParts(b);
    return A.y === B.y && A.m === B.m && A.d === B.d;
  };

  const isUaeFutureDay = (dateLike) => {
    const A = getUaeParts(dateLike);
    const T = getUaeParts(new Date());
    if (A.y !== T.y) return A.y > T.y;
    if (A.m !== T.m) return A.m > T.m;
    return A.d > T.d;
  };

  // ==== ВРЕМЕННЫЕ окна как раньше ====
  const getUaeMinutesNow = () => {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Dubai",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).formatToParts(new Date());
    const h = Number(parts.find((p) => p.type === "hour")?.value || 0);
    const m = Number(parts.find((p) => p.type === "minute")?.value || 0);
    return h * 60 + m;
  };

  const normalize = (s = "") => s.replace(/\s+/g, " ").trim().toLowerCase();

  const optionKind = (val = "") => {
    const v = normalize(val);
    if (v.startsWith("same day delivery")) return "same";
    if (v.startsWith("next day delivery")) return "next";
    if (v.startsWith("2 hours delivery")) return "2h";
    return "other";
  };

  const isOptionEnabledNow = (val) => {
    const now = getUaeMinutesNow();
    // const now = 1200;
    console.log(now, "now");
    const SAME_DAY_END = 9 * 60; // 09:00
    const NEXT_DAY_END = 13 * 60; // 13:00
    const TWO_HOURS_START = 8 * 60; // 08:00
    const TWO_HOURS_END = 16 * 60 + 30; // 16:30

    switch (optionKind(val)) {
      case "same":
        return now < SAME_DAY_END;
      case "next":
        return now < NEXT_DAY_END;
      case "2h":
        return now >= TWO_HOURS_START && now <= TWO_HOURS_END;
      default:
        return true;
    }
  };

  // ==== новая обёртка: учитываем sendDate ====
  const isOptionEnabledForRow = (val, sendDate) => {
    console.log(sendDate);
    if (!sendDate) return isOptionEnabledNow(val); // нет даты — как «сегодня»
    if (isUaeFutureDay(sendDate)) return true; // future day — всё доступно
    if (isUaeSameDay(sendDate, new Date())) {
      return isOptionEnabledNow(val); // сегодня — по окнам
    }
    // прошлый день или что-то экзотическое — оставим текущую логику
    return false;
  };

  const optionTitle = (val, sendDate) => {
    if (sendDate && !isUaeFutureDay(sendDate) && !isUaeSameDay(sendDate, new Date())) {
      return "Send date is in the past (UAE)";
    }

    switch (optionKind(val)) {
      case "same":
        return "Available until 09:00 UAE";
      case "next":
        return "Available until 13:00 UAE";
      case "2h":
        return "Available 08:00–16:30 UAE";
      default:
        return "";
    }
  };

  const columns = [
    {
      text: "No",
      dataField: "",
      sort: true,
      editable: false,
      csvExport: false,
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      headerClasses: "id-header",
    },
    {
      text: "Client Name",
      dataField: "clientName",
      sort: true,
      editable: true,
      formatter: (cellContent, order) => (
        <>
          <p className="mb-0">{order.clientName}</p>
        </>
      ),
    },
    {
      text: "Invoice No",
      dataField: "orderNumber",
      sort: true,
      formatter: (cellContent, order) => (
        <>
          <p className="mb-0">{order.orderNumber}</p>
        </>
      ),
    },
    {
      text: "Placed Date",
      dataField: "placedDate",
      sort: true,
      editable: false,
      formatter: (cellContent, order) => <h5 className="font-size-16 mb-1">{new Date(order.placedDate).toLocaleDateString("en-GB")}</h5>,
    },

    {
      text: "Send Date",
      dataField: "sendDate",
      sort: true,
      csvExport: true,
      hidden: false,
      csvFormatter: (cell, row, rowIndex) => row.sendDate != null && new Date(row.sendDate).toLocaleDateString("en-GB"),
      formatter: (cell, order) => {
        if (!cell) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                lineHeight: "1.2",
              }}
              title='Put "Send date" or ONLY PACK to place the order'
            >
              {/* <BadgeInfo size={32} color="rgb(217, 83, 79)" /> */}
              <span
                style={{
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "12px",
                  textAlign: "center",
                  marginBottom: "4px",
                }}
              >
                PUT "SEND DATE" OR ONLY PACK <br /> TO PLACE THE ORDER
              </span>
            </div>
          );
        }

        if (order.sendDate !== null) {
          let dateObj = order.date;
          if (typeof cell !== "object") {
            dateObj = new Date(cell);
          }
          return dateObj && `${("0" + dateObj.getDate()).slice(-2)}/${("0" + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()}`;
        } else {
          return "";
        }
      },
      editor: {
        type: Type.DATE,
        defaultValue: new Date().toISOString().split("T")[0],
      },
    },

    // {
    //   text: "Send Date",
    //   dataField: "sendDate",
    //   sort: true,
    //   editable: true,
    //   formatter: (cellContent, order) => (
    //     <h5 className="font-size-16 mb-1">
    //       {new Date(order.sendDate).toLocaleDateString("en-GB")}
    //     </h5>
    //   ),
    // },
    {
      text: "Status",
      dataField: "status",
      sort: true,
      editable: false,

      formatter: (cellContent, order) => {
        const meta = getStatusMeta(order.status);

        const hasRealizationNo = Boolean(String(order.realizationNo || "").trim());

        return (
          <div
            className={`d-flex align-items-center justify-content-between rounded-pill px-3 py-2 fw-bold text-white ${meta?.colorClass || "bg-secondary"}`}
            style={{
              width: "290px",
              gap: "8px",
              position: "relative",
              fontSize: "16px",
              textAlign: "center",
              marginTop: "12px",
              marginBottom: "12px",
            }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                gap: "4px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
              }}
            >
              {!order.status && <BadgePlus size={16} color="orange" />}

              {meta?.icon}

              <span>{meta?.label || "Set Status"}</span>
            </div>

            <ChevronDown size={16} className="ms-2" />

            <select
              value={order.status || ""}
              onChange={(e) => {
                const newStatus = e.target.value;

                // Нельзя сохранить Sent без Realization No
                if (newStatus === "sent" && !hasRealizationNo) {
                  return;
                }

                handleSaveCell(order.status, newStatus, order, {
                  dataField: "status",
                });
              }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                opacity: 0,
                cursor: "pointer",
              }}
            >
              <option value="">Set Status</option>

              {STATUS_OPTIONS.filter((option) => {
                const isAdmin = profileData.accType === "Admin";
                const isSales = profileData.department?.depName === "Sales Department";

                if (isAdmin) return true;

                if (isSales) {
                  return ["stopped", "only_pack", "only_pack_allow_send"].includes(option.key);
                }

                return true;
              }).map((option) => {
                const isSentDisabled = option.key === "sent" && !hasRealizationNo;

                return (
                  <option
                    key={option.key}
                    value={option.key}
                    disabled={isSentDisabled}
                    className={isSentDisabled ? "text-danger fw-bold" : ""}
                    style={
                      isSentDisabled
                        ? {
                            color: "#dc3545",
                            fontWeight: 700,
                          }
                        : undefined
                    }
                  >
                    {isSentDisabled ? "⚠ Sent - Realization No required" : option.label}
                  </option>
                );
              })}
            </select>
          </div>
        );
      },

      style: { width: "290px" },
    },
    {
      text: "Address",
      dataField: "address",
      sort: true,
      editable: true,
      formatter: (cell, order) => {
        if (!cell) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                lineHeight: "1.2",
              }}
              title='Put "Address" or ONLY PACK to place the order'
            >
              {/* <BadgeInfo size={32} color="rgb(217, 83, 79)" /> */}
              <span
                style={{
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "12px",
                  textAlign: "center",
                  marginBottom: "4px",
                }}
              >
                PUT "ADDRESS" OR ONLY PACK <br /> TO PLACE THE ORDER
              </span>
            </div>
          );
        }

        return (
          <div className="text-break name-width">
            <h5>{order.address}</h5>
          </div>
        );
      },
    },
    {
      text: "Realization No",
      dataField: "realizationNo",
      sort: true,
      editable: true,
      formatter: (cellContent, order) => (
        <div className="text-break name-width">
          <h5>{order.realizationNo}</h5>
        </div>
      ),
    },
    {
      text: "Tracking",
      dataField: "tracking",
      sort: true,
      editable: true,
      formatter: (cellContent, order) => (
        <>
          <p className="mb-0">{order.tracking}</p>
        </>
      ),
    },
    {
      text: "Comments",
      dataField: "comments",
      sort: true,
      editable: true,
      formatter: (cellContent, order) => (
        <div className="text-break name-width">
          <h5>{order.comments}</h5>
        </div>
      ),
    },
    {
      text: "COD & Currency",
      dataField: "cod",
      sort: true,
      editable: true,
      formatter: (cellContent, order) => (
        <>
          <p className="mb-0">{order.cod}</p>
        </>
      ),
    },
    {
      text: "Send Type",
      dataField: "sendType",
      sort: true,
      editable: false,
      formatter: (cellContent, order) => {
        const isStatusEmpty = !order.status || order.status === "Set Status";
        const options = [
          { value: "", label: "Select Send Type" },
          {
            value: "Same day delivery. Place order before 9am UAE (2pm KST, 1pm MYT)",
            label: "Same day delivery. Place before (2pm KST, 1pm MYT)",
          },
          {
            value: "Next day delivery. Place order before 1pm UAE (5pm KST, 4pm MYT)",
            label: "Next day delivery. Place before (5pm KST, 4pm MYT)",
          },
          {
            value: "2 hours delivery (within Dubai) anytime between 8 AM and 4:30pm UAE (8:30pm KST, 7:30pm MYT)",
            label: "2 hours delivery (within Dubai) anytime between 8 AM and 4:30pm UAE (8:30pm KST, 7:30pm MYT)",
          },
        ];

        const handleChange = (e) => {
          const newVal = e.target.value;
          if (newVal && !isOptionEnabledForRow(newVal, order.sendDate)) {
            // toast.warn('This option is unavailable for the selected send date/time (UAE)');
            e.target.value = order.sendType || "";
            return;
          }
          handleSaveCell(order.sendType, newVal, order, {
            dataField: "sendType",
          });
        };

        return (
          <div>
            {!order.sendType && isStatusEmpty && (
              <div
                style={{
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "12px",
                  textAlign: "center",
                  marginBottom: "4px",
                  marginTop: "6px",
                }}
              >
                SELECT TYPE OF SEND <br /> TO PLACE THE ORDER
              </div>
            )}
            <div className={!order.sendType ? "form-group d-flex align-items-center" : "form-group mt-2 mb-2"}>
              <>
                <select className="form-control status-selection" value={order.sendType || ""} name="sendType" onChange={handleChange} style={{ maxWidth: 700 }}>
                  {options.map((opt) => {
                    const disabled = opt.value ? !isOptionEnabledForRow(opt.value, order.sendDate) : false;

                    return (
                      <option key={opt.value || "placeholder"} value={opt.value} className="alert-primary" disabled={disabled} title={opt.value ? optionTitle(opt.value, order.sendDate) : ""}>
                        {opt.label}
                        {disabled ? " (unavailable)" : ""}
                      </option>
                    );
                  })}
                </select>

                {!order.sendType && <BadgePlus size={20} color="orange" className="ms-2" />}
              </>
            </div>
          </div>
        );
      },
      style: { minWidth: "450px" },
    },
    {
      text: "Manager",
      dataField: "manager",
      sort: true,
      formatter: (cellContent, order) => (
        <div>
          <h5 className="font-size-16 mb-1">
            {order.manager ? (
              <span>
                <div>
                  {!order.manager.profilePic ? (
                    <div className="avatar-sm m-2 d-inline-block">
                      <span className="avatar-title rounded-circle">{order.manager?.fname?.charAt(0)}</span>
                    </div>
                  ) : (
                    <img className="rounded-circle avatar-sm m-2" src={order.manager.profilePic} alt="profile pic" />
                  )}
                  <span>
                    {order.manager.fname} {order.manager.sname}
                  </span>
                  <p className="text-muted mb-0">{order.manager.workEmail}</p>
                </div>
              </span>
            ) : null}
          </h5>
          {/* <h5 className='font-size-16 mb-1'>
            {transfer.manager ? (
              <>
                <span>
                  {transfer.manager.fname}
                  &nbsp;
                  {transfer.manager.sname}
                </span>
                <p className='text-muted mb-0'>{transfer.manager.workEmail}</p>
              </>
            ) : null}
          </h5> */}
        </div>
      ),
    },

    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: `${JSON.parse(localStorage.getItem("authUser")).result.accType === "Admin" ? "Actions" : ""}`,
      formatter: (cellContent, order) => (
        <>
          {JSON.parse(localStorage.getItem("authUser")).result.accType === "Admin" && (
            <div className="d-flex gap-3">
              <>
                <Link className="text-success" to="#">
                  <i className="mdi mdi-pencil font-size-18" id="edittooltip" onClick={() => handleOrderClickEdit(order)}></i>
                </Link>
                <ScrollText
                  size={20}
                  color="#0d6efd"
                  style={{ cursor: "pointer" }}
                  title="View Logs"
                  onClick={() => {
                    setLogModalOrderId(order._id);
                    setShowLogModal(true);
                  }}
                />
                <Link className="text-danger" to="#">
                  <i className="mdi mdi-delete font-size-18" id="deletetooltip" onClick={() => handleOrderClickDelete(order)}></i>
                </Link>
              </>
            </div>
          )}
        </>
      ),
    },
  ];
  const defaultSorted = [
    {
      dataField: "fname", // if dataField is not match to any column you defined, it will be ignored.
      order: "asc", // desc or asc
    },
  ];

  //   const depsOptions = departments.sort((a, b) => a.depName.localeCompare(b.depName)).map(({ _id, depName }) => ({
  //     key: _id,
  //     label: depName,
  //     icon: '',
  //     colorClass: 'bg-primary'
  //   }));
  //   const accTypeOptions = [...new Set(users.map(u => u.accType))].map(type => ({ key: type, label: type, icon: '', colorClass: 'bg-primary' }));
  //   const groupAccessOptions = (accesses) => {
  //     const groups = {};

  //     Object.keys(accesses).forEach((key) => {
  //       if (key === '_id' || key === '__v') return;

  //       // Get prefix (first lowercase part before a capital)
  //       const prefixMatch = key.match(/^[a-z]+/);
  //       const prefix = prefixMatch ? prefixMatch[0] : 'Other';

  //       if (!groups[prefix]) groups[prefix] = [];

  //       groups[prefix].push({
  //         value: key,
  //         text: key
  //           .split(/(?=[A-Z])/)
  //           .join(' ')
  //           .replace(/^./, (c) => c.toUpperCase()),
  //       });
  //     });

  //     return groups;
  //   };
  //   const accessGroups = groupAccessOptions(accesses);
  // const initialSelected = useMemo(() => ({
  //   accountTypes: accTypeOptions
  //     .filter(option => option.key !== 'laid_off')
  //     .map(option => option.key)
  // }), [accTypeOptions]);
  //   const filterFormValues = { accountTypes: ['Employee', 'Outsider', 'Admin'] }
  // const filterFormValues = { statuses: ['eng'] };

  return (
    <React.Fragment>
      <PageLoader progress={progress} step={step} visible={visible} />
      <div className="page-content">
        <MetaTags>
          <title>Priority UAE</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Admin" breadcrumbItem="Priority UAE" />
          <Row className="card-section">
            <Col lg="12">
              <div className="pcss3t logtb pcss3t-effect-scale pcss3t-theme-1">
                <ul>
                  <AnimatePresence key="1" exitBeforeEnter>
                    <motion.li
                      className={`tab-content tab-content-1 typography`}
                      initial={{ opacity: 0, x: 30 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -30 }}
                      transition={{ duration: 0.3 }}
                      style={{ display: "block" }}
                    >
                      <div id="card-section" ref={cardRef}>
                        <Row className="card-section">
                          <Col lg="12">
                            <Card>
                              <CardBody className="cardBodySticky">
                                <ToolkitProvider keyField="_id" columns={columns} data={filteredPriorityUAE} search>
                                  {(props) => (
                                    <React.Fragment>
                                      <MainContent
                                        page={{
                                          pg: "priorityUAE",
                                          props: props,
                                          cardHeight,
                                          showSearch: true,
                                          showCSV: true,
                                          showInTblFltr: true,
                                          showDbFilter: false,
                                          showBtn: true,
                                          columns: props.baseProps.columns,
                                          data: props.baseProps.data,
                                          defaultSorted,
                                          cellEdit: cellEditFactory({
                                            mode: "click",
                                            blurToSave: true,
                                            afterSaveCell: (oldVal, newVal, row, column, rowId) => handleSaveCell(oldVal, newVal, row, column, rowId),
                                          }),
                                        }}
                                        // filter options
                                        filterOptions={{
                                          status: STATUS_OPTIONS,
                                        }}
                                        notificationSettings={{
                                          showNotification: true,
                                          keyword: "priority_uae",
                                          module: "Bot Priority Notification",
                                        }}
                                        // filterDbOptions={{filterFormValues} }
                                        setNoDbFilters={setNoDbFilters}
                                        // options for adding/updating modal and button
                                        btnCrtModalOptions={{
                                          btnLabelCrt: "Add New Order",
                                          modalSize: "xl",
                                          modalTitle: isEdit ? "Edit Order" : "Add Order",
                                          modalBtnLabel: isEdit ? "Edit Order" : "Add Order",
                                          modalAdd: modalNewOrder,
                                          toggleAddModal: toggleNewOrderModal,
                                          handleNewClick: handleNewOrderClick,
                                          modalContent: modalNewOrderContent,
                                          handleSubmit: handleNewOrderSubmit,
                                        }}
                                        // table data opotions
                                        tableOptions={{
                                          includeSelect: true,
                                          manualColumnWidthsIndex: [1],
                                          manualColumnWidths: [90],
                                        }}
                                        // table actions
                                        // tableActions={{
                                        //   globalActionOptions: accessGroups,
                                        //   globalActionBtnLbl: 'APPLY',
                                        //   globalActionExtraContent,
                                        //   handleGlobalActionSubmit
                                        // }}
                                      />

                                      <SweetAlert
                                        show={showDeleteAlert}
                                        danger
                                        showCancel
                                        confirmBtnText="Yes, delete it!"
                                        confirmBtnBsStyle="danger"
                                        title="Are you sure?"
                                        onConfirm={handleDeleteOrder}
                                        onCancel={() => setShowDeleteAlert(false)}
                                        focusCancelBtn
                                      >
                                        <p className="fw-bold">{order.orderNumber}</p>
                                        will be deleted from the system!
                                      </SweetAlert>
                                      <Modal isOpen={showLogModal} toggle={() => setShowLogModal(false)} size="xl" className="log-modal modal-lg-custom">
                                        <ModalHeader toggle={() => setShowLogModal(false)}>
                                          <h3>Order Logs</h3>
                                        </ModalHeader>
                                        <ModalBody>
                                          {logsLoading ? (
                                            <p>Loading logs...</p>
                                          ) : logs.length === 0 ? (
                                            <p>No logs found for this order.</p>
                                          ) : (
                                            <div className="log-timeline">
                                              {logs.map((log) => (
                                                <div key={log._id} className="timeline-item">
                                                  <div className="timeline-dot" />
                                                  <div className="timeline-content">
                                                    <small className="text-muted">
                                                      {new Date(log.timestamp).toLocaleString("en-GB", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        day: "2-digit",
                                                        month: "2-digit",
                                                        year: "numeric",
                                                      })}
                                                      {log.createdBy?.fname && ` • ${log.createdBy.fname} ${log.createdBy.sname}`}
                                                    </small>
                                                    <strong>{log.action}</strong>
                                                    <p className="log-details">{log.details}</p>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                        </ModalBody>
                                      </Modal>
                                    </React.Fragment>
                                  )}
                                </ToolkitProvider>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </motion.li>
                  </AnimatePresence>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
